<template>
  <fieldset v-if="manufacturers.length !== 0" id="catalogManufacturers" class="border-0 mb-4 p-0 px-6">
    <div class="grid grid-cols-2 mb-2">
      <div class="text-xl text-pdsPrimaryColor">Fabrikant</div>
      <div class="text-end">
        <ChevronDownIcon
          @click.prevent="toggleDetails()"
          v-if="!collapsed"
          class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-pdsPrimaryColor cursor-pointer"
          aria-hidden="true"
        />
        <ChevronUpIcon
          @click.prevent="toggleDetails()"
          v-else
          class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-pdsPrimaryColor cursor-pointer"
          aria-hidden="true"
        />
      </div>
    </div>
    <div v-if="!collapsed" class="mb-4">
      <v-checkbox-group
        class="mb-2"
        v-for="(manufacturer, index) in manufacturersByCustomFilter"
        :key="index"
        :label="manufacturer"
        :inputid="'manufacturer' + index"
        :initvalue="selected.indexOf(manufacturer) > -1"
        :overwrite-value="selected.indexOf(manufacturer) > -1"
        @update="change(manufacturer, $event)"
      />
    </div>
  </fieldset>
</template>

<script>
import VCheckboxGroup from './CheckboxGroup';
import { ref, computed } from 'vue';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/vue/20/solid';

export default {
  name: 'VManufacturers',
  components: {
    VCheckboxGroup,
    ChevronDownIcon,
    ChevronUpIcon
  },
  props: {
    manufacturers: Array,
    value: {
      default: () => [],
      type: Array
    }
  },
  setup(props, { emit }) {
    const collapsed = ref(true);
    const selected = ref([]);

    const manufacturersByCustomFilter = computed(() => {
      let computedManufacturers = props.manufacturers;
      computedManufacturers.sort(function (a, b) {
        if (a < b) {
          return -1;
        }
        if (a > b) {
          return 1;
        }
      });
      return computedManufacturers.length > 0 ? computedManufacturers : [];
    });

    const toggleDetails = () => {
      collapsed.value = !collapsed.value;
    };

    const change = (manufacturer, active) => {
      if (active) {
        selected.value.push(manufacturer);
      } else {
        const index = selected.value.findIndex((item) => item.bundleId === manufacturer.bundleId);
        if (index !== -1) {
          selected.value.splice(index, 1);
        }
      }
      emit('update:modelValue', selected.value);
    };

    return {
      selected,
      collapsed,
      toggleDetails,
      change,
      manufacturersByCustomFilter
    };
  }
};
</script>
